import saunaBnbCakeLpFarmingPool65 from "../abis/production/saunaBnb/pools/65";
import saunaBnbCakeLpFarmingPool85 from "../abis/production/saunaBnb/pools/85";
import saunaBnbCakeLpFarmingPool105 from "../abis/production/saunaBnb/pools/105";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "SAUNA-BNB Cake LP Farming",
    temperature: 65,
    type: "bnb",
    contractAddress: "0x262acb69eda34ed724034aea047c90bb86236189",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingPool65.abi,
    url: `${host}/0x262acb69eda34ed724034aea047c90bb86236189`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
  {
    title: "SAUNA-BNB Cake LP Farming",
    temperature: 85,
    type: "bnb",
    contractAddress: "0x55e28ed67df01b27278e6c45805da880741b03ce",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingPool85.abi,
    url: `${host}/0x55e28ed67df01b27278e6c45805da880741b03ce`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
  {
    title: "SAUNA-BNB Cake LP Farming",
    temperature: 105,
    type: "bnb",
    contractAddress: "0x4bc2108ccc85afa799c4201fa323300e4c7897f8",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingPool105.abi,
    url: `${host}/0x4bc2108ccc85afa799c4201fa323300e4c7897f8`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
];
